import React from 'react';

import { CopyText } from './copy_text';

export const CopyURL: React.FC = () => <CopyText text={location.href} />;
